import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Interpreter Framework",
description: "Learn how Freon’s interpreter framework allows you to evaluate models directly from their AST without parsing text, and how to implement a basic interpreter for your DSL.",
tags: [ "interpreter", "interpretation", "AST", "evaluation", "projectional editor", "Freon", "DSL development", "semantics"] ,
modifiedTime: "2025-11-07T17:20:18.625Z",
publishedTime: "2025-11-07T17:20:18.625Z"
    }
  };
};